import { Dashicon, Modal, Spinner } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { Fragment, useEffect, useState } from 'react';
import DisplayConditionsSelectControl from './DisplayConditionsSelectControl';
import UserRolesSelectControl from './UserRolesSelectControl';
import apiFetch from '@wordpress/api-fetch';

export default function DisplayConditions(props) {

    const { closeModal, postID }            = props;
    const postType                          = responsive_addons_site_builder.builderPostType;
    const [ postMeta, setPostMeta ]         = useState(null);
    const [ editedMeta, setEditedMeta ]     = useState({});
    const [ updatingMeta, setUpdatingMeta ] = useState(false);
    const [ errorMessage, setErrorMessage ] = useState(null)

    useEffect(() => {
        apiFetch({ path: `/wp/v2/${postType}/${postID}` })
            .then(data => {
                setPostMeta(data.meta);
                setEditedMeta(data.meta);
            })
            .catch(e => console.error("Error fetching post meta: ", e));
    }, [postID, postType]);

    const saveMeta = async () => {
        setUpdatingMeta(true);
        setErrorMessage(null);
        try {
            const response = await apiFetch({
                path: `/wp/v2/${postType}/${postID}`,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': responsive_addons_site_builder?.nonce,
                },
                body: JSON.stringify({
                    meta: editedMeta
                }),
            });

            setPostMeta(response.meta);
            closeModal(); // close after saving
        } catch (error) {
            console.error('Failed to update post:', error);
            setErrorMessage(error.message || 'An unknown error occurred while saving the conditions.');
        } finally {
            setUpdatingMeta(false);
        }
    };

     const updateEditedMeta = (key, value) => {
        setEditedMeta(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <Modal
            title={__("Display & User Conditions", "responsive-addons")}
            onRequestClose={ closeModal }
            shouldCloseOnClickOutside={ false }
            className='!max-w-3xl max-h-[600px] rounded-lg h-auto !w-full responsive-sb-admin-display-rules-modal'
        >
            { ! postMeta ? 
                <div className='text-center py-8'>
                    <Spinner style={{
                        height: '30px',
                        width: '30px'
                    }} /> 
                </div>
                : 
                <div>
                    <table className='responsive-sb-admin-modal-table w-full border-none bg-white'>
                        <tbody>
                            { "404-page" !== editedMeta["responsive-site-builder-layout"] &&
                                <Fragment>
                                    <tr>
                                        <td className='p-6 border border-border w-1/4 text-sm text-[#333333]'><label>{__("Display On", "responsive-addons")}</label></td>
                                        <td className='border border-border w-3/4 align-middle pt-[22px] pr-6 pb-[14px] pl-[23px]'>
                                            <DisplayConditionsSelectControl
                                                value            = {editedMeta["responsive-site-builder-layout-location"]}
                                                metaKey          = "responsive-site-builder-layout-location"
                                                updateEditedMeta = {updateEditedMeta}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className='p-6 border border-border w-1/4 text-sm text-[#333333]'><label>{__("Do Not Display On", "responsive-addons")}</label></td>
                                        <td className='border border-border w-3/4 align-middle pt-[22px] pr-6 pb-[14px] pl-[23px]'>
                                            <DisplayConditionsSelectControl
                                                value            = {editedMeta["responsive-site-builder-layout-exclusion"]}
                                                metaKey          = "responsive-site-builder-layout-exclusion"
                                                updateEditedMeta = {updateEditedMeta}
                                            />
                                        </td>
                                    </tr>
                                </Fragment>
                            }
                            <tr>
                                <td className='p-6 border border-border border-b-0 w-1/4 text-sm text-[#333333]'>
                                    <label>{__("Display For Users", "responsive-addons")}</label>
                                </td>
                                <td className='border border-border border-b-0 w-3/4 align-middle pt-[14px] pr-8 pb-[22px] pl-[23px]'>
                                    <UserRolesSelectControl
                                        value            = {editedMeta["responsive-site-builder-layout-users"]}
                                        metaKey          = "responsive-site-builder-layout-users"
                                        updateEditedMeta = {updateEditedMeta}
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            }
            <div className='flex justify-between px-6 py-4 border-t-[1px] border-border sticky bottom-0 z-10 bg-white'>
                <span className='flex gap-1 items-center text-sm text-[#333333]'>
                    <Dashicon icon="warning" size={18}></Dashicon>
                    {__("Please make sure to save any changes made to take effect.", "responsive-addons")}
                </span>
                <button
                    onClick={ saveMeta }
                    disabled={updatingMeta}
                    className={`text-sm text-white font-medium rounded border bg-btnPrimary px-5 py-2 hover:bg-sky-600 ${
                        updatingMeta ? 'cursor-not-allowed' : ''
                    }`}
                >
                    { updatingMeta ? __("Saving...", "responsive-addons") : __("Save", "responsive-addons") }
                </button>
            </div>
            {errorMessage && (
                <div className="text-red-600 text-xs px-8 pb-4 text-center">
                    {__("Failed to update post conditions: ", "responsive-addons")}{errorMessage}
                </div>
            )}
        </Modal>
    )
}